import { InfoIcon, MAX_CAMPAIGN_PERIOD_DAYS, MIN_CAMPAIGN_PERIOD_DAYS, PeriodDatePicker, Typography } from '@analytical-alley/ui';
import moment from 'moment';

type Props = {
    startDate: string;
    endDate: string;
    constraints: { minDate: string; maxDate: string; visibleMinDate: Date; visibleMaxDate: Date };
    disabled: boolean;
    onChange: (startDate: string, endDate: string) => void;
};

const parse = (value: string) => moment(value, 'DD-MM-YYYY').toDate();

export const PeriodField = ({ startDate, endDate, constraints, disabled, onChange }: Props) => (
    <div className="space-y-1 flex flex-col gap-1">
        <Typography variant="bodyS" className="flex gap-2">
            Optimization Period
            <InfoIcon>Choose the campaign period to optimize for. Changing the period will affect available KPI range.</InfoIcon>
        </Typography>
        <div className={disabled ? 'opacity-60 pointer-events-none' : ''}>
            <PeriodDatePicker
                startDate={parse(startDate)}
                endDate={parse(endDate)}
                minDate={parse(constraints.minDate)}
                maxDate={parse(constraints.maxDate)}
                visibleMinDate={constraints.visibleMinDate}
                visibleMaxDate={constraints.visibleMaxDate}
                minPeriodDays={MIN_CAMPAIGN_PERIOD_DAYS}
                maxPeriodDays={MAX_CAMPAIGN_PERIOD_DAYS}
                onDateChange={(start, end) => onChange(moment(start).format('DD-MM-YYYY'), moment(end).format('DD-MM-YYYY'))}
                autoApply
                side="bottom"
            />
        </div>
    </div>
);
